import { createSlice } from "@reduxjs/toolkit";

export const iaamSlice = createSlice({
    name: 'iaam',
    initialState: {
        value: undefined
    },
    reducers: {
        setIAAM: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setIAAM } = iaamSlice.actions;

export const getIAAM = (state) => state.iaam.value;

export default iaamSlice.reducer;